export const ACTION_PREFIX = 'EF_CHECKOUT_CONFIRMATION';
export const PARTITION = 'efCheckoutConfirmation';

export const actionTypes = {
  CONFIRM_PAY_PENDING: 'CONFIRM_PAY_PENDING',
  CONFIRM_PAY_FULFILLED: 'CONFIRM_PAY_FULFILLED',
  CONFIRM_PAY_REJECTED: 'CONFIRM_PAY_REJECTED',
  DECLINE_CHECKOUT_PENDING: 'DECLINE_CHECKOUT_PENDING',
  DECLINE_CHECKOUT_FULFILLED: 'DECLINE_CHECKOUT_FULFILLED',
  DECLINE_CHECKOUT_REJECTED: 'DECLINE_CHECKOUT_REJECTED',
  GET_LOAN_AGREEMENT_DETAILS_PENDING: 'GET_LOAN_AGREEMENT_DETAILS_PENDING',
  GET_LOAN_AGREEMENT_DETAILS_FULFILLED: 'GET_LOAN_AGREEMENT_DETAILS_FULFILLED',
  GET_LOAN_AGREEMENT_DETAILS_REJECTED: 'GET_LOAN_AGREEMENT_DETAILS_REJECTED',
};
